import RadioV2 from './RadioV2';

export default RadioV2;
